// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2-ymc","inputWrap":"styles_inputWrap__3ioNh","input":"styles_input__3Wras"};